module.exports = __webpack_public_path__ + "static/media/bg5.2a8f6326.jpg";